import { RootState } from "@/store";
import { useSelector } from "react-redux";

export const useFilterEngineHistoryState = () => {
  return useSelector((state: RootState) => state.filterEngineHistory);
};
